import { api } from 'shared/api'

import {
  FeedbackSegmentInsightsBlockSchemas,
  FeedbackTikTokExperienceSchemas,
  SetDisplayFlagSchemas,
} from './schema'

export const accountUserApi = {
  feedbackTikTokExperience: api.account.createPost({
    url: '/accountUser/feedbackTikTokExperience',
    schemas: FeedbackTikTokExperienceSchemas,
  }),
  feedbackSegmentInsightsBlock: api.account.createPost({
    url: '/accountUser/feedbackSegmentInsightsBlock',
    schemas: FeedbackSegmentInsightsBlockSchemas,
  }),
  setDisplayFlag: api.account.createPost({
    url: '/accountUser/setDisplayFlag',
    schemas: SetDisplayFlagSchemas,
  }),
}
